<template>
  <div class="row">
    <step
      v-for="(step, index) in steps"
      :key="index"
      :step="step"
      @step:clicked="updateActiveStep"
    />
    <step
      :step="finalStep"
      @step:clicked="clickFinalStep"
    >
      <label class="text-center d-block w-100">{{ finalStep.label }}</label>
    </step>
  </div>
</template>
<script>
import Step from './Step'
import '~style/components/stepper.scss'

const INACTIVE = 0
const COMPLETED = 1
const NOT_PURCHASED = 2
const DISABLED = 3
const ENROLL = 0
const PURCHASE = 1

export default {
  name: 'LarStepper',
  components: {
    Step
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    activeStep: {
      type: String,
      required: true
    },
    enableFinalStep: Boolean
  },
  data () {
    return {
      finalStep: {
        label: '送出報名表',
        stage: DISABLED,
        isActive: false
      }
    }
  },
  watch: {
    activeStep (value) {
      if (value !== '送出報名表') {
        this.updateActiveStep(this.steps.find(step => step.label === value))
      }
    },
    enableFinalStep (value) {
      if (value) {
        this.finalStep.stage = INACTIVE
        this.clickFinalStep()
      }
    }
  },
  methods: {
    resetActiveStep () {
      const currentStep = this.steps.findIndex(step => step.isActive === true)
      if (currentStep > -1) {
        const newStep = Object.assign({}, this.steps[currentStep], {
          isActive: false
        })
        this.steps.splice(currentStep, 1, newStep)
      } else {
        this.finalStep = Object.assign({}, this.finalStep, {
          isActive: false
        })
      }
    },
    updateActiveStep (currentStep) {
      this.resetActiveStep()
      const newStep = Object.assign({}, currentStep, {
        isActive: true
      })
      this.steps.splice(this.steps.findIndex(step => step.label === currentStep.label), 1, newStep)
      this.$emit('active:updated', newStep.label)
    },
    clickFinalStep () {
      this.resetActiveStep()
      this.finalStep = Object.assign({}, this.finalStep, {
        isActive: true
      })
      this.$emit('active:updated', this.finalStep.label)
    }
  }
}
</script>
